module.exports = __webpack_public_path__ + "img/tuskegee-logo.6bc088ed.jpg";